import React from 'react';
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBTable,
  MDBTableBody,
  MDBTableHead
} from 'mdbreact';
import { NumberWithComma } from '../../functions/NumberWithComma';

const CashReportTable = ({ tableHead, cash }) => {
  const data_panel = {
    columns: [
      {
        label: 'ر.ت.',
        field: 'number',
        sort: 'asc'
      },
      {
        label: 'العنوان',
        field: 'title'
        // sort: 'asc'
      },
      {
        label: 'القيمة',
        field: 'amount'
        // sort: 'asc'
      }
    ],
    rows: [
      {
        number: '1',
        title: 'الرصيد الافتتاحي',
        amount: NumberWithComma(cash?.openingBalance)
      },
      {
        number: '2',
        title: 'الإيراد',
        amount: NumberWithComma(cash?.Revenue)
      },
      {
        number: '3',
        title: 'المصاريف',
        amount: NumberWithComma(cash?.Cost)
      },
      {
        number: '4',
        title: 'المشتريات',
        amount: NumberWithComma(cash?.Purchase)
      },
      {
        number: '5',
        title: 'الديون المسلَّمة',
        amount: NumberWithComma(cash?.debtReceived)
      },
      {
        number: '6',
        title: 'الديون المسترجعة',
        amount: NumberWithComma(cash?.debtReturned)
      },
      {
        number: '7',
        title: 'القروض المستلمة',
        amount: NumberWithComma(cash?.loanRecevied)
      },
      {
        number: '8',
        title: 'القروض المسددة',
        amount: NumberWithComma(cash?.loanReturned)
      },
      {
        number: undefined,
        title: 'الإجمالي الكلي',
        amount: NumberWithComma(cash?.total)
      }
    ]
  };

  return (
    <MDBCard narrow>
      <MDBCardHeader className="view view-cascade gradient-card-header blue-gradient d-flex justify-content-center align-items-center py-2 mx-4 mb-3">
        <h1 className="white-text mx-3">{tableHead}</h1>
      </MDBCardHeader>
      <MDBCardBody cascade>
        <MDBTable btn fixed>
          <MDBTableHead columns={data_panel.columns} />
          <MDBTableBody rows={data_panel.rows} />
        </MDBTable>
      </MDBCardBody>
    </MDBCard>
  );
};

export default CashReportTable;
